import React, { useState, useEffect, useContext, ChangeEvent, useRef } from "react";
import {
  Layout,
  Menu,
  Tabs,
  Form,
  Input,
  Select,
  Button,
  Upload,
  message,
  Row,
  Col,
  Typography,
  Spin,
  UploadFile,
  Divider,
  Space,
  Table,
  Tooltip,
  Modal,
  List,
  TableProps,
} from "antd";
import { SearchOutlined, UploadOutlined } from "@ant-design/icons";
import { CompanyCode } from "../../core/interfaces/CompanyCode";
import {
  fetchBusinessReportCode,
  FetchCompany,
  fetchCompanyCodes,
  fetchEmpDetails,
  fetchReportCodes,
  FetchReviewUsers,
  SaveApprovalRequest,
  SaveCCAttachment,
  SaveCCRequest,
  SaveCCRequestDetails,
} from "../../core/services/account-request.service";
import { ReportCode } from "../../core/interfaces/ReportCode";
import { UserContext } from "../../context/user-context";
import { useNavigate } from "react-router-dom";
import { BusinessUnit } from "../../core/interfaces/BusinessUnit";
import { kMaxLength } from "buffer";
import { Employee } from "../../core/interfaces/Employee";
import TextArea from "antd/es/input/TextArea";
import { valueType } from "antd/es/statistic/utils";
import { Approval } from "../../core/interfaces/Approval";
import { CCRequestFormValue } from "../../core/interfaces/CCRequestFormValues";
import { CalClient } from '@cvx/cal';
import { environment } from "../../../src/environments/environment"
import { User } from "../../../src/core/interfaces/User"
import { ReqStatus } from "../../core/interfaces/ReqStatus";
import { UploadFileStatus } from "antd/es/upload/interface";
import { postAttachData } from "../../core/services/api.service";
import axios from "axios";
import { appInsights } from "../../core/services/insight.service";
import { set } from "date-fns";
import GlobalErrorMessage from "../global-error/GlobalErrorMessage";
import { JdCompany } from "../../core/interfaces/JdCompany";

const { Header, Content, Footer } = Layout;
const { TabPane } = Tabs;
const { Option } = Select;
const { Title } = Typography;
interface DropdownOption {
  value: string;
  label: string;
}
type UploadStatus = 'idle' | 'uploading' | 'success' |'error';
const CCRequest: React.FC = () => {
  const [sessionID, setSessionID] = useState<string>("");
  const [requester, setRequester] = useState<string>("");
  const [businessUnits, setBusinessUnits] = useState<BusinessUnit[]>([]);
  const [dropdownData, setDropdownData] = useState<DropdownOption[]>([]);
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const [selectedRequesterName, setSelectedRequesterName] = useState<string>("");
  const [open,setOpen] = useState(false);
  const [empData, setEmpData] = useState<Employee[]>([]);
  const [totalSteps] = useState(5);
  const [isHelpVisible, setIsHelpVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [requestDate, setRequestDate] = useState<string>(new Date().toLocaleDateString());
  const [reason, setReason] = useState<string>("");
  const [company, setCompany] = useState<Number>(0);
  const [actionCode, setActionCode] = useState<string>("A");
  const [postEdit, setPostEdit] = useState<string>("");
  const [ccType, setCcType] = useState<string>("");
  const [file1, setFile1] = useState<File | null>(null);
  const [file2, setFile2] = useState<File | null>(null);
  const [file3, setFile3] = useState<File | null>(null);
  const [status, setStatus] = useState<UploadStatus>('idle');
  const [companyCodes, setCompanyCodes] = useState<CompanyCode[]>([]);
  const [companyCode, setCompanyCode] = useState<JdCompany>({} as JdCompany);
  const [businessUnit, setbusinessUnit] = useState<ReportCode[]>([]);
  const [buModified, setBuModified] = useState<number | 1>(1);
  const contextUser = React.useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState<number | 1>(1);
  const [management, setManagement] = useState<ReportCode[]>([]);
  const [managementType, setmanagmentType] = useState<string>("");
  const [division, setDivision] = useState<ReportCode[]>([]);
  const [divisionType, setdivisionType] = useState<string>("");
  const [subDivision, setSubDivision] = useState<ReportCode[]>([]);
  const [subDivisionType, setSubdivisionType] = useState<string>("");
  const [departMent, setDepartMent] = useState<ReportCode[]>([]);
  const [departmentType, setdepartmentType] = useState<string>("");
  const [subDepartMent, setSubDepartMent] = useState<ReportCode[]>([]);
  const [subDepartmentType, setsubDepartmentType] = useState<string>("");
  const [functions, setFunctions] = useState<ReportCode[]>([]);
  const [functionType, setfunctionType] = useState<string>("");
  const [allocationMaterials, setAllocationMaterials] = useState<ReportCode[]>([]);
  const [allocationMaterialsType, setallocationMaterialsType] = useState<string>("");
  const [allocationGA, setAllocationGA] = useState<ReportCode[]>([]);
  const [allocationGAType, setallocationGAType] = useState<string>("");
  const [allocationOpres, setAllocationOpres] = useState<ReportCode[]>([]);
  const [allocationOpresType, setallocationOpresType] = useState<string>("");
  const [allocationTiers, setAllocationTiers] = useState<ReportCode[]>([]);
  const [allocationTiersType, setallocationTiersType] = useState<string>("");
  const [jvChargeability, setjvChargeability] = useState<ReportCode[]>([]);
  const [jvChargeabilityType, setjvChargeabilityType] = useState<string>("");
  const [jvCode, setjvCode] = useState<ReportCode[]>([]);
  const [jvCodeType, setjvCodeType] = useState<string>("");
  const [businessActivity, setbusinessActivity] = useState<ReportCode[]>([]);
  const [businessActivityType, setbusinessActivityType] = useState<string>("");
  const [primaryDiscipline, setprimaryDiscipline] = useState<ReportCode[]>([]);
  const [primaryDisciplineType, setprimaryDisciplineType] = useState<string>("");
  const [tbd15, settbd15] = useState<ReportCode[]>([]);
  const [tbd15type, settbd15type] = useState<string>("");
  const [soApprovalRoute, setsoApprovalRoute] = useState<ReportCode[]>([]);
  const [soApprovalRouteType, setsoApprovalRouteType] = useState<string>("");
  const [interfaceControl1, setinterfaceControl1] = useState<ReportCode[]>([]);
  const [interfaceControl1TYpe, setinterfaceControl1TYpe] = useState<string>("");
  const [interfaceControl2, setinterfaceControl2] = useState<ReportCode[]>([]);
  const [interfaceControl2Type, setinterfaceControl2Type] = useState<string>("");
  const [Localization1, setLocalization1] = useState<ReportCode[]>([]);
  const [Localization1Type, setLocalization1Type] = useState<string>("");
  const [Localization2, setLocalization2] = useState<ReportCode[]>([]);
  const [Localization2Type, setLocalization2Type] = useState<string>("");
  const [SAPTranmissionCode, setSAPTranmissionCode] = useState<ReportCode[]>([]);
  const [SAPTranmissionCodeType, setSAPTranmissionCodeType] = useState<string>("");
  const [CapitalExpense, setCapitalExpense] = useState<ReportCode[]>([]);
  const [CapitalExpenseType, setCapitalExpenseType] = useState<string>("");
  const [SponsporBu, setSponsporBu] = useState<ReportCode[]>([]);
  const [SponsporBuType, setSponsporBuType] = useState<string>("");
  const [LocalGaap, setLocalGaap] = useState<ReportCode[]>([]);
  const [LocalGaapType, setLocalGaapType] = useState<string>("");
  const [ManagementReporting, setManagementReporting] = useState<ReportCode[]>([]);
  const [ManagementReportingType, setManagementReportingType] = useState<string>("");
  const [Asset, setAsset] = useState<ReportCode[]>([]);
  const [AssetType, setAssetType] = useState<string>("");
  const [Universal, setUniversal] = useState<ReportCode[]>([]);
  const [UniversalType, setUniversalType] = useState<string>("");
  const [Area, setArea] = useState<ReportCode[]>([]);
  const [AreaType, setAreaType] = useState<string>("");
  const [Block, setBlock] = useState<ReportCode[]>([]);
  const [BlockType, setBlockType] = useState<string>("");
  const [Field, setField] = useState<ReportCode[]>([]);
  const [FieldType, setFieldType] = useState<string>(""); 
  const [approvers, setApprovers] = useState<Approval[]>([]); 
  const [faApprovers, setfaApprovers] = useState<Approval[]>([]);
  const [faApproversType, setfaApproversType] = useState<string>("");
  const [jvApprovers, setjvApprovers] = useState<Approval[]>([]);
  const [selectedjvApprovers, setselectedjvApprovers] = useState<string>("");
  const [pscApprovers, setpscApprovers] = useState<Approval[]>([]);
  const [selectedpscApprovers, setSelectedpscApprovers] = useState<string>("");
  const [gasApprovers, setgasApprovers] = useState<Approval[]>([]);
  const [selectedgasApprovers, setselectedgasApprovers] = useState<string>("");
  const [interCoApprovers, setinterCoApprovers] = useState<Approval[]>([]);
  const [selectedinterCoApprovers, setselectedinterCoApprovers] = useState<string>("");
  const [allocationapprovers, setallocationapprovers] = useState<Approval[]>([]);
  const [selectedallocationapprovers, setselectedallocationapprovers] = useState<string>("");
  const [fixedAssetapprovers, setfixedAssetapprovers] = useState<Approval[]>([]);
  const [selectedfixedAssetapprovers, setselectedfixedAssetapprovers] = useState<string>("");
  const [productionAccountingapprovers, setproductionAccountingapprovers] = useState<Approval[]>([]);
  const [selectedproductionAccountingapprovers, setselectedproductionAccountingapprovers] = useState<string>("");
  const [CCRequestResponse, setCCRequestResponse] = React.useState<CCRequestFormValue>({} as CCRequestFormValue); 
  const [CCRequestDetailsResponse, setCCRequestDetailsResponse] = React.useState<CCRequestFormValue>({} as CCRequestFormValue); 
  const [CCApprovalResponse, setCCApprovalResponse] = React.useState<CCRequestFormValue>({} as CCRequestFormValue);  
  const [formrequest] = Form.useForm<CCRequestFormValue>();
  const [formrapproval] = Form.useForm<CCRequestFormValue>();
  const [employeeDept, setEmployeeDept] = useState<string>(""); // New state for department
  const [graphUser, setGraphUser] = useState<User>({});
  const cal = new CalClient(environment.calConfig);
  const user = useContext(UserContext);
  const getUserEmail = async () => {
    const response = await cal.getUserPropertiesFromMsGraph([
    "userPrincipalName"
    ]);
  setGraphUser((prev) => ({ ...prev, ...user }));
  setGraphUser((prev) => ({ ...prev, Emaild: response.userPrincipalName }));
  };
  const [jvdeatils, setjvdeatils] = useState<string>("");
  const [pscDetails,setpscDetails] = useState<string>("");
  const [bpcDetails,setbpcDetails] = useState<string>("");
  const [alloDetails,setalloDetails] = useState<string>("");
  const [prodDetails,setprodDetails] = useState<string>("");
  const [interDetails,setinterDetails] = useState<string>("");
  const [fixDetails,setfixDetails]= useState<string>("");
  const [gasDetails,setgasDetails] = useState<string>("");
  const [issucess, setIssucess] = useState<boolean>(false);
  const [apiError, setApiError] = useState(null);
  const navigate = useNavigate();
  const userProfile = useContext(UserContext);
  const effectRan = useRef(false);

  useEffect(() => {
    
    const initializeData = async () => {
      try {
        setLoading(true);
        await getUserEmail();
        await fetchBusinessReportCodes();
        await fetchCompanyCodesData();
        await fetchAllReportCodes();
        const approversData = await FetchReviewUsers(
          userProfile
        );
        setApprovers(approversData);

        // Filter approvers by groups
        setfaApprovers(approversData.filter((a) => a.appgroup === 1));
        setjvApprovers(approversData.filter((a) => a.appgroup === 2));
        setpscApprovers(approversData.filter((a) => a.appgroup === 3));
        setgasApprovers(approversData.filter((a) => a.appgroup === 4));
        setinterCoApprovers(approversData.filter((a) => a.appgroup === 5));
        setallocationapprovers(approversData.filter((a) => a.appgroup === 6));
        setproductionAccountingapprovers(approversData.filter((a) => a.appgroup === 8));
        setfixedAssetapprovers(approversData.filter((a) => a.appgroup === 9));

        // Set initial business units
        setBusinessUnits([{ key: 1, businessUnit: "", description: "" }]);

        // Set dropdown data
        setDropdownData([
          { value: "1", label: "Option 1" },
          { value: "2", label: "Option 2" },
          { value: "3", label: "Option 3" },
        ]);

        // Set requester email if available
        if (contextUser.email) {
          setRequester(contextUser.email);
        }
      } catch (error) {
        setApiError(error);
        console.error("Error initializing data:", error);
      } finally {
        setLoading(false);
      }
    };
    if (effectRan.current === false) {
      initializeData();
    effectRan.current = true;
  }
  }, [contextUser]);

  const buModifiedOptions: JSX.Element[] = [];
  let x = 0;
  while (x < 20) {
    buModifiedOptions.push(
      <Option key={x + 1} value={x + 1}>
        {x + 1}
      </Option>
    );
    x = x + 1;
  }
  const handleChange = (value: number) => {
    setBuModified(value);
    const updatedBusinessUnits = Array.from({ length: value }, (_, index) => ({
        key: index + 1,
        businessUnit: "",
        description: "",
    }));
    setBusinessUnits(updatedBusinessUnits);
  };
  const fetchCompanyCodesData = async () => {
    setLoading(true);
    let data = await fetchCompanyCodes(userProfile);
    setCompanyCodes(data);
    setLoading(false);
  };
const fetchBusinessReportCodes = async () => {
    setLoading(true);
    // Define all the types you want to fetch
    const types = [
      { drsy: "00", drrt: "MC", type: "BUSINESS_UNIT" },
    ]
    try {
      const response = await fetchBusinessReportCode("00","'MC'"); // Adjust the API endpoint as needed
      for (const type of types) {
        const matchingData = response.filter((item: ReportCode) => item.drrt === type.drrt);
        if (matchingData.length > 0) {
          switch (type.type) {
        case "BUSINESS_UNIT":
          setbusinessUnit(matchingData);
          break;
        default:
          break;
        }
      }
    }
  } catch (error) {
    setApiError(error);
    console.error("Error fetching report codes:", error);
  }
}
  const fetchAllReportCodes = async () => {
    setLoading(true);
    // Define all the types you want to fetch
    const types = [
      { drrt: "01", type: "MANAGEMENT" },
      { drrt: "02", type: "DIVISION" },
      { drrt: "03", type: "SUB_DIVISION" },
      { drrt: "04", type: "DEPARTMENT" },
      { drrt: "05", type: "SUB_DEPARTMENT" },
      { drrt: "06", type: "FUNCTION" },
      { drrt: "07", type: "ALLOCATIONS_MATERIALS" },
      { drrt: "08", type: "ALLOCATIONS_GA" },
      { drrt: "09", type: "ALLOCATIONS_OPRES" },
      { drrt: "10", type: "ALLOCATION_TIERS" },
      { drrt: "11", type: "JV_Chargeability" },
      { drrt: "12", type: "JV_Code" },
      { drrt: "13", type: "Business_Activity" },
      { drrt: "14", type: "Primary_Discipline" },
      { drrt: "15", type: "TBD-15" },
      { drrt: "16", type: "SO_Approval_Route" },
      { drrt: "17", type: "Interface-Control_1" },
      { drrt: "18", type: "Interface-Control_2" },
      { drrt: "19", type: "Localization_1" },
      { drrt: "20", type: "Localization_2" },
      { drrt: "21", type: "SAP_Transmission_Code" },
      { drrt: "22", type: "Capital/Expense_AFE" },
      { drrt: "23", type: "AFE-Sponsor_BU" },
      { drrt: "24", type: "Local_GAAP" },
      { drrt: "25", type: "Management_Reporting-Taxes" },
      { drrt: "26", type: "Geographical_Level-Asset" },
      { drrt: "27", type: "Geographical-Universal_Well_ID" },
      { drrt: "28", type: "Geographical_Level-Area" },
      { drrt: "29", type: "Geographical_Level-Block" },
      { drrt: "30", type: "Geographical_Level-Field" },
    ];
    try {

      const commaSeparated = types.map(obj => `'${obj.drrt}'`).join(',');
      const response = await fetchReportCodes("00",commaSeparated); // Adjust the API endpoint as needed
      for (const type of types) {
        const matchingData = response.filter((item) => item.drrt === type.drrt);
        if (matchingData.length > 0) {
          switch (type.type) {
            case "MANAGEMENT":
              setManagement(matchingData);
              break;
            case "DIVISION":
              setDivision(matchingData);
              break;
            case "SUB_DIVISION":
              setSubDivision(matchingData);
              break;
            case "DEPARTMENT":
              setDepartMent(matchingData);
              break;
            case "SUB_DEPARTMENT":
              setSubDepartMent(matchingData);
              break;
            case "FUNCTION":
              setFunctions(matchingData);
              break;
            case "ALLOCATIONS_MATERIALS":
              setAllocationMaterials(matchingData);
              break;
            case "ALLOCATIONS_GA":
              setAllocationGA(matchingData);
              break;
            case "ALLOCATIONS_OPRES":
              setAllocationOpres(matchingData);
              break;
            case "ALLOCATION_TIERS":
              setAllocationTiers(matchingData);
              break;
            case "JV_Chargeability":
              setjvChargeability(matchingData);
              break;
            case "JV_Code":
              setjvCode(matchingData);
              break;
            case "Business_Activity":
              setbusinessActivity(matchingData);
              break;
            case "Primary_Discipline":
              setprimaryDiscipline(matchingData);
              break;
            case "TBD-15":
              settbd15(matchingData);
              break;
            case "SO_Approval_Route":
              setsoApprovalRoute(matchingData);
              break;
            case "Interface-Control_1":
              setinterfaceControl1(matchingData);
              break;
            case "Interface-Control_2":
              setinterfaceControl2(matchingData);
              break;
            case "Localization_1":
              setLocalization1(matchingData);
              break;
            case "Localization_2":
              setLocalization2(matchingData);
              break;
            case "SAP_Transmission_Code":
              setSAPTranmissionCode(matchingData);
              break;
            case "Capital/Expense_AFE":
              setCapitalExpense(matchingData);
              break;
            case "AFE-Sponsor_BU":
              setSponsporBu(matchingData);
              break;
            case "Local_GAAP":
              setLocalGaap(matchingData);
              break;
            case "Management_Reporting-Taxes":
              setManagementReporting(matchingData);
              break;
            case "Geographical_Level-Asset":
              setAsset(matchingData);
              break;
            case "Geographical-Universal_Well_ID":
              setUniversal(matchingData);
              break;
            case "Geographical_Level-Area":
              setArea(matchingData);
              break;
            case "Geographical_Level-Block":
              setBlock(matchingData);
              break;
            case "Geographical_Level-Field":
              setField(matchingData);
              break;
            default:
              break;
          }
        }
      }
      
    } catch (error) {
      setApiError(error);
      console.error("Error fetching report codes:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    setIsModalVisible(true);
  }
  const handlecancel = () => {
    setIsModalVisible(false);
  };
  const handleok = () => {
    setIsModalVisible(false);
    navigate("/home");
  };

  const handleBack = () => {
    setCurrentTab((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = async () => {
    if(currentTab === 1)
    {
    setIsHelpVisible(true);
    if(managementType !== "" && divisionType !== "")
    {
      setIsHelpVisible(false);
    }
  }
  if(currentTab === 2)
  {
    if(managementType !== "" && divisionType !== "")
    {
      setIsHelpVisible(false);
    }
  }
  setCurrentTab((prev) => Math.min(prev + 1, 6));
  };
  const SetCompanyCode = async (e: any) => {
    setLoading(true);
    try {
      const response = await FetchCompany(e); // Ensure FetchCompany returns an array
      setCompanyCode(response); // Ensure response is an array of BusinessUnit
    } catch (error) {
      setApiError(error);
      console.error(error);
      setCompanyCode({} as JdCompany); // Reset to an empty array on error
    } finally {
      setLoading(false);
    }
  };

  function handleFileChange1(e: ChangeEvent<HTMLInputElement>)
  {
    if(e.target.files)
    {
      setFile1(e.target.files[0]);
    }
  }
  function handleFileChange2(e: ChangeEvent<HTMLInputElement>)
  {
    if(e.target.files)
    {
      setFile2(e.target.files[0]);
    }
  }
  function handleFileChange3(e: ChangeEvent<HTMLInputElement>)
  {
    if(e.target.files)
    {
      setFile3(e.target.files[0]);
    }
  }

  const handleFinish =  async () => {
    setLoading(true);
    if(currentTab === 5)
    {
      if(selectedUser === "")
      {
        message.error("approverEmail is required");
      }
      if(faApproversType === "")
      {
        message.error("FaApprovers is required");
      }
    }
    const ccRequestData: CCRequestFormValue = {
    Requester: graphUser.email,
    RequestDate: new Date(),
    ActioncCode: actionCode,
    Company: company.toString(),
    Reason: reason,
    PostEdit: postEdit,
    CcType : ccType,
    RC1: managementType,
    RC2: divisionType,
    RC3: subDivisionType,
    RC4:departmentType,
    RC5:subDepartmentType,
    RC6:functionType,
    RC7:allocationMaterialsType,
    RC8:allocationGAType,
    RC9:allocationOpresType,
    RC10:allocationTiersType,
    RC11:jvChargeabilityType,
    RC12:jvCodeType,
    RC13:businessActivityType,
    RC14:primaryDisciplineType,
    RC15:tbd15type,
    RC16:soApprovalRouteType,
    RC17:interfaceControl1TYpe,
    RC18:interfaceControl2Type,
    RC19:Localization1Type,
    RC20:Localization2Type,
    RC21:SAPTranmissionCodeType,
    RC22:CapitalExpenseType,
    RC23:SponsporBuType,
    RC24:LocalGaapType,
    RC25:ManagementReportingType,
    RC26:AssetType,
    RC27:UniversalType,
    RC28:AreaType,
    RC29:BlockType,
    RC30:FieldType,
    RequesterName: graphUser.email,
    RequesterDept: employeeDept || "UNKNOWN",
    Attachmnt1: file1?.name || "",
    Attachmnt2: file2?.name || "",
    Attachmnt3: file3?.name || "",
    }
    const ccrequestresponse = await SaveCCRequest(ccRequestData); 
    sessionStorage.setItem("ccRequestID", ccrequestresponse.requestID?.toString() || "");
    const storedRequestID = sessionStorage.getItem("ccRequestID");
     setStatus("uploading");
          const fileDataArray = [
            { file: file1, key: "file1" },
            { file: file2, key: "file1" },
            { file: file3, key: "file1" },
          ];
          for (const fileData of fileDataArray) {
            if (fileData.file) {
              const formData = new FormData();
              if (storedRequestID) {
                formData.append("requestid", storedRequestID);
              }
              formData.append(fileData.key, fileData.file);
          
              const formValues = Object.fromEntries(formData);
              try {
                await SaveCCAttachment(formValues);
              } catch (error) {
                setApiError(error);
                console.error(`Failed to upload ${fileData.key}:`, error);
              }
            }
          }
    const ccRequestDetailsData: CCRequestFormValue = {
      requestID: storedRequestID ? parseInt(storedRequestID, 10) : undefined,
      CCENTER: companyCode.locationCode.toString() + "" + businessUnits.map(unit => unit.businessUnit).join(", "),
      CCDESC: businessUnits.map(unit => unit.description).join(", "),
      DONE:"N"
    }
    const ccrequestdetailsresponse = await SaveCCRequestDetails(ccRequestDetailsData);
    const reqStatus: ReqStatus = ReqStatus.PendingApprovalByLine;
    const ccRequestApprovalData: CCRequestFormValue = {
      Line: selectedUser || "",
      requestID: storedRequestID ? parseInt(storedRequestID, 10) : undefined,
      LineDate: new Date(),
      LineAppr: "N",
      LineComments: "",
      FA: faApproversType,
      FADate:new Date(),
      FAAppr: "N",
      FAExm: "",
      FAComments: "",
      JV: selectedjvApprovers,
      JVDate:new Date(),
      JVAppr: "N",
      JVEXM: jvdeatils,
      JVComments: "",
      PSC: selectedpscApprovers,
      PSCDate:new Date(),
      PSCAppr: "N",
      PSCEXM: pscDetails,
      PSCComments: "",
      GAS: selectedgasApprovers,
      GASDate:new Date(),
      GASAppr: "N",
      GASEXM: gasDetails,
      GASComments: "",
      INTER: selectedinterCoApprovers,
      INTERDate:new Date(),
      INTERAppr: "N",
      INTEREXM: interDetails,
      INTERComments: "",
      ALLO: selectedallocationapprovers,
      ALLODate:new Date(),
      ALLOAppr: "N",
      ALLOEXM: alloDetails,
      ALLOComments: "",
      COMP: "l9lek513",
      COMPDate:new Date(),
      COMPAppr: "N",
      COMPComments: "",
      FixAss: selectedfixedAssetapprovers,
      FIXASSDate:new Date(),
      FIXASSAppr: "N",
      FIXASSEXM: alloDetails,
      FIXASSComments: "",
      PROD: selectedproductionAccountingapprovers,
      PRODDate:new Date(),
      PRODAppr: "N",
      PRODEXM: alloDetails,
      PRODComments: "",
      STATUS: reqStatus,
      PENDINGON: selectedUser ||"",
      URL: "ccRequestDetails.aspx?requestNumber=" + "" + storedRequestID,
      UPDATEDBY: graphUser.email,
      UPDATEDATE: new Date(),
      HasReroute: "N",
    } 
    const ccrequestapprovalresponse = await SaveApprovalRequest(ccRequestApprovalData); 
    setCCRequestResponse(ccrequestresponse);
    setCCRequestDetailsResponse(ccrequestdetailsresponse);
    setCCApprovalResponse(ccrequestapprovalresponse);
    setLoading(false);
    setIssucess(true);
    setTimeout(() => {
      setIssucess(false);
      navigate("/home");
    }, 10000); // Redirect after 5 seconds
  };
  const handleclose = () =>  {
    navigate("/home");
  }
  const setRequesters = (text:string,name:string) => {
    setSelectedRequesterName(name);
    setSelectedUser(text);
    setOpen(false);
    setEmpData([]);
 }
 const showModal = async(e: any) => {
  setSelectedUser(e);
  setOpen(true);
  if (e && e.trim() !== "") {
    await SearchUser(e);
  } else {
    setEmpData([]);
  }
};
 const SearchUser = async(text:any) => {
    setLoading(true);
    try {
        const response = await fetchEmpDetails(text); // Adjust the API endpoint as needed
        setEmpData(response);
        appInsights.trackEvent({ name: "Search User Success", properties: { userId: user.email, searchText: text } });
      } catch (error) {
        setApiError(error);
        message.error("Failed to fetch users");
        appInsights.trackException({ exception: error as Error, properties: { Component:'ReviewSetup', method:'SearchUser', context: 'Search User', userId: user.email, searchText: text } }); // Track exception
      } finally {
        setLoading(false);
      }  
};
const handleOk = async(e: any) =>  {
  setOpen(false);
  }

  const handleempCancel = async(e: any) =>  {
    setOpen(false)
  }
  function handleModalInputChange(e: string): void {
    setSelectedUser(e);
  }
  const handleRetry = () => {
    setApiError(null);
  };
  const column : TableProps<Employee>['columns']  = [
      {
          title: "S/N",
          dataIndex: "index",
          key: "index",
          render: (text: string, record: Employee, index: number) =>
          `${index + 1}.`,
          width:'15%'
      },
      {
        title: 'Name',
        dataIndex: 'fullName',
        key: 'fullName',
        render:(text)=> <a >{text}</a>,
        width: '20%',
      },
      {
        title: 'User ID/Email ID',
        dataIndex: 'emailAddress',
        key: 'emailAddress',
        align: 'center',
        width: '20%',
      },
      {
        title: 'PhoneExt',
        dataIndex: 'phoneExt',
        key: 'phoneExt',
        width: '15%',
      },
      
      {
        title: 'Department',
        dataIndex: 'deptName',
        key: 'deptName',
        width: '20%',
      },
      {
        title: 'Location',
        dataIndex: 'locationName',
        key: 'locationName',
        width: '20%',
      },
    ];
  const columns = [
    {
      title: "S/N",
      dataIndex: "key",
      key: "key",
      render: (text: number) => `${text}.`,
    },
    {
      title: "* Business Unit",
      dataIndex: "businessUnit",
      key: "businessUnit",
      render: (_: any, record: BusinessUnit, index: number) => (
        <>  
        <Input value={companyCode.locationCode} 
        disabled
        style={{ width: "150px" }}/>
        <Input
          placeholder="Enter Business Unit"
          value={record.businessUnit}
          maxLength={6} // Restrict input to 6 characters
          required={true}
          style={{ width: "150px" }} // Reduce the width of the input field
          onChange={(e) => {
            const newUnits = [...businessUnits];
            newUnits[index].businessUnit = e.target.value;
            setBusinessUnits(newUnits);
          } } /></>
        ),
      },
      {
        title: "* Business Unit Description",
        dataIndex: "description",
        key: "description",
        render: (_: any, record: BusinessUnit, index: number) => (
          <><Input
            placeholder="Enter Description"
            value={record.description}
            maxLength={30} // Restrict input to 6 characters
            required={true}
            style={{ width: "250px" }} // Reduce the width of the input field
            onChange={(e) => {
              const newUnits = [...businessUnits];
              newUnits[index].description = e.target.value;
              setBusinessUnits(newUnits);
            } } /><span>(Max: 30)</span></>
        ),
      },
    ];
  return (
     <>
         {apiError ? (
                   <GlobalErrorMessage 
                   error={apiError}
                   visible={!!apiError}
                   onClose={() => setApiError(null)}
                   onRetry={handleRetry}
                 />
                 ) : (
    <Spin spinning={loading}>
      <div>
        <p>Notes:</p>
        <p>1. This Form can be used to Add/Change BUSINESS UNITS</p>
        <p>2. * marked fields are required</p>
      </div>
      <div className="site-layout-content">
        <div className="div-container">
          <Tabs defaultActiveKey="1"
           activeKey={currentTab.toString()}
           onChange={(key) => setCurrentTab(Number(key))}>
            <TabPane tab="Business Unit Request" key="1">
              <Title
                level={4}
                style={{ textAlign: "left", marginBottom: "20px" }}
              >
                Business Unit Request Details
              </Title>
              <Form form={formrequest} onFinish={handleFinish}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Requester"
                      name="requester"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <Input
                        placeholder={requester}
                        value={requester}
                        disabled
                      />
                      {/* <Input value={contextUser.email} disabled /> */}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Date"
                      name="date"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <Input
                        value={requestDate}
                        placeholder={requestDate}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Action Code"
                      name="actionCode"
                      rules={[{ required: true }]}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      initialValue="A"
                    >
                      <Select value={actionCode} onChange={(value) => setActionCode(value)}>
                        <Option value="A">A - Add</Option>
                        <Option value="U">U - Update</Option>
                        <Option value="D">D - Deactivate</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Company"
                      name="company"
                      rules={[{ required: true }]}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <Select value={company} onChange={setCompany}
                      onSelect={(e) => SetCompanyCode(e)}>
                        <option value=""></option>
                        {companyCodes.map((code) => (
                          <option key={code.ccco} value={code.ccco}>
                            {code.cccO_NAME}
                          </option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Reason for request"
                      name="reason"
                      rules={[{ required: true }]}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <Input.TextArea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        maxLength={499}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Posting Edit"
                      name="postingEdit"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <Select value={postEdit} onChange={setPostEdit}>
                        <option value=""></option>
                        <option value="N">N</option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Business Unit Type"
                      name="businessUnitType"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <Select value={ccType} onChange={setCcType}>
                      <option value=""></option>
                        {businessUnit.map((code) => (
                          <option key={code.drdL01} value={code.drkY_DL01}>
                            {code.drkY_DL01}
                          </option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label={
                        <span style={{ whiteSpace: "normal" }}>
                          Number of Business <br />
                          Units being Modified
                        </span>
                      }
                      name="businessUnitsModified"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      initialValue={1}
                    >
                      <Select
                        value={buModified}
                        onChange={(value) => handleChange(value)}
                      >
                        {buModifiedOptions}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Divider>Business Units</Divider>
                <Table
                dataSource={businessUnits}
                columns={columns}
                pagination={false}
                bordered
                rowKey="key" // Use the "key" property as the unique identifier
                />
                <Divider>Attachments</Divider>
                <Row gutter={16}>
                  <Col span={12}>
                  <span>Attachments</span>
                    <Form.Item
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                    <Input type="file" onChange={handleFileChange1} ></Input>
                    <Input type="file" onChange={handleFileChange2} ></Input>
                    <Input type="file" onChange={handleFileChange3} ></Input>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                  <span>Attach any files that are relevant to this request.</span>
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginLeft: "380px" }}>
                  <Col span={24}>
                  <Form.Item>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Button onClick={handleCancel}>Cancel</Button>
                      <Button onClick={handleBack} disabled={currentTab === 1}>
                        Back
                        </Button>
                        <div>
                          Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                          </div>
                          <Button 
                            onClick={handleNext} 
                            disabled={
                              currentTab === 5 || 
                              (currentTab === 1 && (
                                !actionCode || 
                                !company.toString() || 
                                !reason || 
                                companyCode.locationCode == 0 ||
                                businessUnits.some((unit) => !unit.businessUnit || !unit.description)
                              ))
                            }
                          >
                            Next
                          </Button>
                          <Button onClick={handleFinish} disabled={currentTab !== 5}>Finish</Button>
                            </div>
                            </Form.Item>
                            </Col>
                            </Row>
              </Form>
            </TabPane>
            <TabPane tab="Cat Codes 1 - 10" key="2"     
            disabled={
              !actionCode ||
              !company.toString() ||
              !reason ||
              companyCode.locationCode === 0 ||
              businessUnits.some((unit) => !unit.businessUnit || !unit.description)
              }>
              <div className="panel pnl-repCodes step-2" id="tb-reportCodes-1-10">
      <Title level={3}>Category Codes 1 - 10</Title>
      <Form form={formrequest} onFinish={handleFinish} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Management:" name="management" rules={[{ required: true, message: "Please select Management!" }]}>
            <Select value={managementType} onChange={setmanagmentType} showSearch>
            <option value=""></option>
             {management.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
                        
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Division:" name="division" rules={[{ required: true, message: "Please select Division!" }]}>
            <Select value={divisionType} onChange={setdivisionType}>
            <option value=""></option>
             {division.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Sub-Division:" name="subDivision">
            <Select value={subDivisionType} onChange={setSubdivisionType}>
            <option value=""></option>
             {subDivision.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Department:" name="department">
            <Select value={departmentType} onChange={setdepartmentType}>
            <option value=""></option>
             {departMent.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Sub-Department:" name="subDepartment">
            <Select value={subDepartmentType} onChange={setsubDepartmentType}>
            <option value=""></option>
             {subDepartMent.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Function:" name="function">
            <Select value={functionType} onChange={setfunctionType}>
            <option value=""></option>
             {functions.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Allocations - Materials:" name="allocationsMaterials">
            <Select value={allocationMaterialsType} onChange={setallocationMaterialsType}>
            <option value=""></option>
             {allocationMaterials.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Allocations - GA:" name="allocationsGA">
            <Select value={allocationGAType} onChange={setallocationGAType}>
            <option value=""></option>
             {allocationGA.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Allocations - OpRes:" name="allocationsOpRes">
            <Select value={allocationOpresType} onChange={setallocationOpresType}>
            <option value=""></option>
             {allocationOpres.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Allocation - Tiers:" name="allocationTiers">
            <Select value={allocationTiersType} onChange={setallocationTiersType}>
            <option value=""></option>
             {allocationTiers.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginLeft: "380px" }}>
                  <Col span={24}>
                  <Form.Item>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Button onClick={handleCancel}>Cancel</Button>
                      <Button onClick={handleBack} disabled={currentTab === 1}>
                        Back
                        </Button>
                        <div>
                          Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                          </div>
                          <Button onClick={handleNext} disabled={currentTab === 5 ||
                             (currentTab === 2 && (
                              !managementType || 
                              !divisionType
                            ))
                          }>
                            Next
                            </Button>
                            <Button onClick={handleFinish} disabled={currentTab !== 5}>
                            Finish</Button>
                            </div>
                            </Form.Item>
                            </Col>
                            </Row>
      </Form>
    </div>
            </TabPane>
            <TabPane tab="Cat Codes 11 - 20" key="3"
                disabled={
                  !actionCode ||
                  !company.toString() ||
                  !reason ||
                  companyCode.locationCode === 0 ||
                  businessUnits.some((unit) => !unit.businessUnit || !unit.description) ||
                  !managementType ||
                  !divisionType
                }>
            <div className="panel pnl-repCodes step-3" id="tb-reportCodes-11-20">
      <Title level={3}>Category Codes 11 - 20</Title>
      <Form form={formrequest} onFinish={handleFinish} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="JV Chargeability:" name="jvChargeability" rules={[{ required: true, message: "This field is required" }]}>
            <Select value={jvChargeabilityType} onChange={setjvChargeabilityType}>
            <option value=""></option>
             {jvChargeability.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="JV Code:" name="jvCode" rules={[{ required: true, message: "This field is required" }]}>
            <Select value={jvCodeType} onChange={setjvCodeType}>
            <option value=""></option>
             {jvCode.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Business Activity:" name="businessActivity" rules={[{ required: true, message: "This field is required" }]}>
            <Select value={businessActivityType} onChange={setbusinessActivityType}>
            <option value=""></option>
             {businessActivity.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Primary Discipline:" name="primaryDiscipline">
            <Select value={primaryDisciplineType} onChange={setprimaryDisciplineType}>
            <option value=""></option>
             {primaryDiscipline.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="TBD - 15:" name="tbd15">
            <Select value={tbd15type} onChange={settbd15type}>
            <option value=""></option>
             {tbd15.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="SO Approval Route:" name="soApprovalRoute">
            <Select value={soApprovalRouteType} onChange={setsoApprovalRouteType}>
            <option value=""></option>
             {soApprovalRoute.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Interface - Control 1:" name="interfaceControl1">
            <Select value={interfaceControl1TYpe} onChange={setinterfaceControl1TYpe}>
            <option value=""></option>
             {interfaceControl1.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Interface - Control 2:" name="interfaceControl2">
            <Select value={interfaceControl2Type} onChange={setinterfaceControl2Type}>
            <option value=""></option>
             {interfaceControl2.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Localization 1:" name="localization1">
            <Select value={Localization1Type} onChange={setLocalization1Type}>
            <option value=""></option>
             {Localization1.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Localization 2:" name="localization2">
            <Select value={Localization2Type} onChange={setLocalization2Type}>
            <option value=""></option>
             {Localization2.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginLeft: "380px" }}>
                  <Col span={24}>
                  <Form.Item>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Button onClick={handleCancel}>Cancel</Button>
                      <Button onClick={handleBack} disabled={currentTab === 1}>
                        Back
                        </Button>
                        <div>
                          Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                          </div>
                          <Button onClick={handleNext} disabled={currentTab === 5 ||
                             (currentTab === 3 && (
                              !jvChargeabilityType || 
                              !jvCodeType ||
                              !businessActivityType
                            ))
                          }>
                            Next
                            </Button>
                            <Button onClick={handleFinish} disabled={currentTab !== 5}>Finish</Button>
                            </div>
                            </Form.Item>
                            </Col>
                            </Row>
      </Form>
    </div>
            </TabPane>
            <TabPane tab="Cat Codes 21 - 30" key="4"
             disabled={
              !actionCode ||
              !company.toString() ||
              !reason ||
              companyCode.locationCode === 0 ||
              businessUnits.some((unit) => !unit.businessUnit || !unit.description) ||
              !managementType ||
              !divisionType ||
              !jvChargeabilityType ||
              !jvCodeType ||
              !businessActivityType
            }>
            <div className="panel pnl-repCodes step-4" id="tb-reportCodes-21-30">
      <Title level={3}>Category Codes 21 - 30</Title>
      <Form layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="SAP Transmission Code:" name="sapTransmissionCode">
            <Select value={SAPTranmissionCodeType} onChange={setSAPTranmissionCodeType}>
            <option value=""></option>
             {SAPTranmissionCode.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Capital/Expense AFE:" name="capitalExpenseAFE">
            <Select value={CapitalExpenseType} onChange={setCapitalExpenseType}>
            <option value=""></option>
             {CapitalExpense.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="AFE - Sponsor BU:" name="afeSponsorBU">
            <Select value={SponsporBuType} onChange={setSponsporBuType}>
            <option value=""></option>
             {SponsporBu.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Local GAAP:" name="localGAAP">
            <Select value={LocalGaapType} onChange={setLocalGaapType}>
            <option value=""></option>
             {LocalGaap.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Management Reporting - Taxes:" name="managementReportingTaxes">
            <Select value={ManagementReportingType} onChange={setManagementReportingType}>
            <option value=""></option>
             {ManagementReporting.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Geographical Level - Asset:" name="geographicalLevelAsset">
            <Select value={AssetType} onChange={setAssetType}>
            <option value=""></option>
             {Asset.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Geographical - Universal Well ID:" name="geographicalUniversalWellID">
            <Select value={UniversalType} onChange={setUniversalType}>
            <option value=""></option>
             {Universal.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Geographical Level - Area:" name="geographicalLevelArea">
            <Select value={AreaType} onChange={setAreaType}>
            <option value=""></option>
             {Area.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Geographical Level - Block:" name="geographicalLevelBlock">
            <Select value={BlockType} onChange={setBlockType}>
            <option value=""></option>
             {Block.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Geographical Level - Field:" name="geographicalLevelField">
            <Select value={FieldType} onChange={setFieldType}>
            <option value=""></option>
             {Field.map((code) => (
                          <option key={code.drky} value={code.drky}>
                            {code.drkY_DL01}
                          </option>
                        ))}
            </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginLeft: "380px" }}>
                  <Col span={24}>
                  <Form.Item>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Button onClick={handleCancel}>Cancel</Button>
                      <Button onClick={handleBack} disabled={currentTab === 1}>
                        Back
                        </Button>
                        <div>
                          Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                          </div>
                          <Button onClick={handleNext} disabled={currentTab === 5}>
                            Next
                            </Button>
                            <Button onClick={handleFinish} disabled={currentTab !== 5}>Finish</Button>
                            </div>
                            </Form.Item>
                            </Col>
                            </Row>
      </Form>
    </div>
            </TabPane>
            <TabPane tab="Reviewing Route" key="5"
             disabled={
              !actionCode ||
              !company.toString() ||
              !reason ||
              companyCode.locationCode === 0 ||
              businessUnits.some((unit) => !unit.businessUnit || !unit.description) ||
              !managementType ||
              !divisionType ||
              !jvChargeabilityType ||
              !jvCodeType ||
              !businessActivityType
            }>
            <div className="reviewing-route">
      <Title level={3}>Reviewing Route</Title>

      <Form  form={formrapproval} layout="vertical">
        {/* Approver Email */}
        <Row>
        <Col>
          <Form.Item     
          label="Approver Email ID"
              name="approvalemailid"
              tooltip="Enter the email address of the approver"
              rules={[{ required: true }]}>
            </Form.Item>
          </Col>
        <Col style={{ marginLeft: "40px" }}>
           <Input
                       placeholder="Approval Email ID"
                       value={selectedUser|| ""}
                       onChange={(e) => setSelectedUser(e.target.value)}
                       style={{ width: '200px', marginRight: '10px' }}/>
                      <a onClick={() => showModal(selectedUser)}>
                      <SearchOutlined />
                      </a>
                      {selectedRequesterName && (<span style={{ marginLeft: 10 }}> {selectedRequesterName} </span>)}
        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Financial Accounting"
            name="financialAccounting"
            rules={[{ required: true, message: "Please select an option!" }]}
          >
             <Select value={faApproversType} onChange={setfaApproversType}>
             <option value=""></option>
             {faApprovers.map((code) => (
                          <option key={code.emailID} value={code.emailID}>
                            {code.name}
                          </option>
                        ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          {/* Placeholder for future input */}
        </Col>
      </Row>
      <Row gutter={16}>
      <Col span={8}>
      </Col>
      <Col span={16}>
            <Typography.Text type="secondary">* Reasons are needed if Approver is not selected</Typography.Text>
      </Col>
      </Row>
      <Row gutter={16}>
      <Col span={8}>
          <Form.Item
            label="Joint Venture"
            name="jointVenture"
          >
         <Select value={selectedjvApprovers} onChange={setselectedjvApprovers}>
         <option value=""></option>
         {jvApprovers.map((code) => (
                          <option key={code.emailID} value={code.emailID}>
                            {code.name}
                          </option>
                        ))}
            </Select>
          </Form.Item>
        </Col>
          <Col span={16}>
          <Form.Item label="Joint Venture Details" name="jointVentureDetails">
            <Input.TextArea 
                    value={jvdeatils} 
                    onChange={(e) => setjvdeatils(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                     />
          </Form.Item>
        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="PSC"
            name="psc"
          >
           <Select value={selectedpscApprovers} onChange={setSelectedpscApprovers}>
           <option value=""></option>
             {pscApprovers.map((code) => (
                          <option key={code.emailID} value={code.emailID}>
                            {code.name}
                          </option>
                        ))}
            </Select>
          </Form.Item>
        </Col>
          <Col span={16}>
          <Form.Item label="PSC Details" name="pscDetails">
            <Input.TextArea 
                    value={pscDetails} 
                    onChange={(e) => setpscDetails(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                     />
          </Form.Item>
        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Gas"
            name="gas"
          >
            <Select value={selectedgasApprovers} onChange={setselectedgasApprovers}>
            <option value=""></option>
             {gasApprovers.map((code) => (
                          <option key={code.emailID} value={code.emailID}>
                            {code.name}
                          </option>
                        ))}
            </Select>
          </Form.Item>
        </Col>
          <Col span={16}>
          <Form.Item label="Gas Details" name="gasDetails">
          <Input.TextArea 
                    value={gasDetails} 
                    onChange={(e) => setgasDetails(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                     />
          </Form.Item>
        </Col>
        </Row>
        {/* InterCo Section */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="InterCo:" name="interCo">
          <Select value={selectedinterCoApprovers} onChange={setselectedinterCoApprovers}>
          <option value=""></option>
             {interCoApprovers.map((code) => (
                           <option key={code.emailID} value={code.emailID}>
                            {code.name}
                          </option>
                        ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item label="Details" name="interCoDetails">
          <Input.TextArea 
                    value={interDetails} 
                    onChange={(e) => setinterDetails(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                     />
          </Form.Item>
        </Col>
      </Row>
       {/* Allocation Section */}
       <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="Allocation:" name="allocation" >
          <Select value={selectedallocationapprovers} onChange={setselectedallocationapprovers}>
          <option value=""></option>
             {allocationapprovers.map((code) => (
                          <option key={code.emailID} value={code.emailID}>
                            {code.name}
                          </option>
                        ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item label="Details" name="allocationDetails">
          <Input.TextArea 
                    value={alloDetails} 
                    onChange={(e) => setalloDetails(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                     />
          </Form.Item>
        </Col>
      </Row>
        {/* Fixed Asset Section */}
        <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="Fixed Asset:" name="fixedAsset" >
          <Select value={selectedfixedAssetapprovers} onChange={setselectedfixedAssetapprovers}>
          <option value=""></option>
          {fixedAssetapprovers.map((code) => (
                           <option key={code.emailID} value={code.emailID}>
                            {code.name}
                          </option>
                        ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item label="Details" name="fixedAssetDetails">
          <Input.TextArea 
                    value={fixDetails} 
                    onChange={(e) => setfixDetails(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                     />
          </Form.Item>
        </Col>
      </Row>
       {/* Production Accounting Section */}
       <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Production Accounting:"
            name="productionAccounting"
          >
            <Select value={selectedproductionAccountingapprovers} onChange={setselectedproductionAccountingapprovers}>
            <option value=""></option>
             {productionAccountingapprovers.map((code) => (
                          <option key={code.emailID} value={code.emailID}>
                            {code.name}
                          </option>
                        ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item label="Details" name="productionAccountingDetails">
          <Input.TextArea 
                    value={prodDetails} 
                    onChange={(e) => setprodDetails(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                     />
          </Form.Item>
        </Col>
      </Row>
          {/* Hidden Fields */}
          <Form.Item name="bpc" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="bpcDetails" hidden>
      <Input.TextArea 
                    value={bpcDetails} 
                    onChange={(e) => setbpcDetails(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                     />
      </Form.Item>
        <Row gutter={16} style={{ marginLeft: "380px" }}>
                  <Col span={24}>
                  <Form.Item>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Button onClick={handleCancel}>Cancel</Button>
                      <Button onClick={handleBack} disabled={currentTab === 1}>
                        Back
                        </Button>
                        <div>
                          Step <Typography.Text strong>{currentTab}</Typography.Text> of <Typography.Text strong>{totalSteps}</Typography.Text>
                          </div>
                          <Button onClick={handleNext} disabled={currentTab === 5}>
                            Next
                            </Button>
                            <Button onClick={handleFinish}
                             disabled={currentTab !== 5 ||
                              (currentTab === 5 && (
                                !selectedUser ||
                                !faApproversType ||
                                !actionCode || 
                                !company.toString() || 
                                !reason || 
                                companyCode.locationCode == 0 ||
                                businessUnits.some((unit) => !unit.businessUnit || !unit.description) ||
                                !managementType || 
                                !divisionType ||
                                !jvChargeabilityType || 
                                !jvCodeType ||
                                !businessActivityType ||
                                (selectedjvApprovers === "" && jvdeatils === "") ||
                                (selectedpscApprovers === "" && pscDetails === "") ||
                                (selectedgasApprovers === "" && gasDetails === "") ||
                                (selectedinterCoApprovers === "" && interDetails === "") ||
                                (selectedallocationapprovers === "" && alloDetails === "") ||
                                (selectedfixedAssetapprovers === "" && fixDetails === "") ||
                                (selectedproductionAccountingapprovers === "" && prodDetails === "")
                              )
                            )
                            }
                            >Finish</Button>
                            </div>
                            </Form.Item>
                            </Col>
                            </Row>
      </Form>
    </div>
    
    </TabPane>
    </Tabs> 
    </div>
    </div>
    <Modal
        title="Search For Employee"
        open={open}
        onOk={handleOk}
        onCancel={handleempCancel}
        width={1000}
        >
            <Divider></Divider>
            <Space direction="vertical">
            <Row gutter={[16,32]} >
                <Col span={16}>
                    <div>Enter Search Query</div>
               </Col>
            </Row>
            <Row gutter={[16,32]}>
                <Col span={18}>
                    <div >
                    <Input value={selectedUser|| ""} onChange={(e) => handleModalInputChange(e.target.value)}/>
                    </div>
                </Col>
                <Col span={6}>
                    <div >
                    <Button type="primary" onClick={()=>SearchUser(selectedUser)}>Search</Button>
                    </div>
                </Col>
            </Row>
                 
            </Space>
            
            <Table
                dataSource={empData}
                columns={column}
                pagination={false}
                scroll={{ y: 150 }}
                loading={loading}
                locale={{ emptyText: 'No matching record found. Kindly refine your criteria!' }}
                onRow={(record) => ({
                    onClick: () => setRequesters(record.emailAddress, record.fullName),
                  })}
                style={{marginTop: '20px'}}
                size='small'
                />

            <Divider></Divider>
      </Modal>
    <div style={{ marginTop: "20px" }}>
    <Modal
        title="accreqnew-dev.azure.chevron.com says"
        open={isModalVisible}
        onOk={handleok}
        onCancel={handlecancel}
      >
        <p>This would return you to the Default page. The data entered has not been saved, and will be lost if you continue!'</p>
        <p>Click "Cancel" to return and continue this reqest, or click "OK" to discard data and return to Default page.</p>
      </Modal>
      </div>
    <div style={{ marginTop: "20px" }}>
      <Modal 
        open={issucess}
        onCancel={handleclose}
        footer={null}
      >
        <Title level={4}>Operation Sucessfull!</Title>
      <Typography.Text>Business Request {CCRequestDetailsResponse.requestID} has been successfully created.</Typography.Text>
      <br />
      <Typography.Text>The window will now exit this page.</Typography.Text>
      </Modal>
      </div>
      <div style={{ marginTop: "20px" }}>
      <Modal 
      open={isHelpVisible}
      footer={null}
      closable={false} 
      afterOpenChange={(visible) => {
        if (visible) {
          setTimeout(() => {
            setIsHelpVisible(false);
          }, 5000);
        }
      }}
      >
        <Title level={4}>Having Issues Completing this Form?</Title>
        <List
          dataSource={[
            "You have to complete all required fields to move on to the next step.",
            "You cannot finish a request if any of the steps is incomplete.",
            "For content assistance, please contact John-Bosco Ogbuehi (jxxa@chevron.com) on Ext: 69813.",
          ]}
          renderItem={(item) => <List.Item>{item}</List.Item>}
        />
      </Modal>
      </div>
    </Spin>
  )}
  </>
  );
};
export default CCRequest;